import { QueryClient, isServer } from '@tanstack/react-query';

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
        gcTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
        // 2 retries (backoff exp ~1s, ~3s) : laisse passer la fenêtre transitoire de ~1-2s
        // où la session est invalide (rotation du token Supabase après une action POST en
        // rafale, ex. désactiver/réactiver une boîte) — sinon l'API redirige vers /login et
        // une query à retry=1 abandonnait avant la recovery. Cf. get-thread-client (détection
        // du redirect auth) + email-inbox (garde le cache sur erreur transitoire).
        retry: 2,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}

let browserQueryClient: QueryClient | undefined;

export function getQueryClient() {
  if (isServer) {
    return makeQueryClient();
  }
  if (!browserQueryClient) {
    browserQueryClient = makeQueryClient();
  }
  return browserQueryClient;
}
